/* @flow */

import React from 'react';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import axios from 'axios';

async function confirmCancel({ confirmationTitle = 'Ben je zeker?', confirmationMessage = 'Deze actie kan niet ongedaan gemaakt worden.', link, responseHandler }) {
    const confirmed = await swal({
        title: confirmationTitle,
        text: confirmationMessage,
        icon: 'warning',
        dangerMode: true,
        buttons: ['Annuleer', 'Verwijder'],
    });

    if (confirmed) {
        axios.delete(link, { maxRedirects: 0 }).then(responseHandler);
    }
}

function DeleteButton(props) {
    let responseHandler;
    if (props.idToRemove) {
        responseHandler = () => { document.getElementById(props.idToRemove).remove(); };
    } else {
        responseHandler = () => { window.location.reload(); };
    }

    const confirmationProps = {
        ...props,
        responseHandler,
    };

    return (
        <div>
            <a className="btn btn-danger" onClick={() => confirmCancel(confirmationProps)}>{props.buttonText}</a>
        </div>
    );
}

DeleteButton.propTypes = {
    buttonText: PropTypes.string,
    confirmationTitle: PropTypes.string,
    confirmationMessage: PropTypes.string,
    link: PropTypes.string,
    idToRemove: PropTypes.string,
};

export default DeleteButton;



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/components/DeleteButton.js